import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-52bb8eeb")

_pushScopeId("data-v-52bb8eeb")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("アカウント登録")
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, "Eメールアドレスに送信された認証番号を入力してください。", -1)
const _hoisted_3 = { class: "number-frame" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("ログイン画面に戻る")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("アカウント登録できました。ログイン画面に戻ってログインして下さい。 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_logo = _resolveComponent("logo")
  const _component_page_description = _resolveComponent("page-description")
  const _component_six_digits = _resolveComponent("six-digits")
  const _component_link_text = _resolveComponent("link-text")
  const _component_vue_login_form = _resolveComponent("vue-login-form")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_login_frame = _resolveComponent("vue-login-frame")

  return (_openBlock(), _createBlock(_component_vue_login_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_login_form, null, {
        default: _withId(() => [
          _createVNode("h1", null, [
            _createVNode(_component_logo),
            _hoisted_1
          ]),
          _createVNode(_component_page_description, null, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_six_digits, {
              ref: "sixDigitRef",
              modelValue: _ctx.digits,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.digits = $event)),
              onEnter: _ctx.onEnter
            }, null, 8, ["modelValue", "onEnter"])
          ]),
          _createVNode(_component_link_text, { link: "/login" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmRef",
        "yes-only": true,
        onYes: _ctx.yes
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})